module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp2_5010.a3976f2a.png";